<template>
  <path pid="0" d="M18.13 25.4zM18.52 25.29l-.09.05zM10 3.41zM23.5 2.13L17 5.87 9.45 2.11 9.22 2h-.59l-.13.06-7 4A1 1 0 001 7v16a1 1 0 001.5.87L9 20.13l7.52 3.76.22.08h.59l.13-.06 7-4A1 1 0 0025 19V3a1 1 0 00-1.5-.87zM8 18.42l-5 2.86V7.58l5-2.86zm8 3l-6-3V4.62l6 3zm7-3l-5 2.86V7.58l5-2.86zM9.58 3.52h.09z"/>
</template>
